module.exports = __webpack_public_path__ + "img/oval1.cc51c14c.png";